import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { InlineEditProvider } from '../components/admin/InlineEditContext';
import AdminService from '../services/adminService';
import Home from './Home';
import Services from './Services';
import Professional from './Professional';
import About from './About';
import Contact from './Contact';
import Dashboard from './Dashboard';

const PAGE_MAP = {
  accueil: Home,
  services: Services,
  service: Services,
  professional: Professional,
  professionnel: Professional,
  apropos: About,
  about: About,
  contact: Contact,
  dashboard: Dashboard
};

const AdminEditPage = () => {
  const { pageSlug } = useParams();
  const slug = (pageSlug || '').toLowerCase();
  const Component = PAGE_MAP[slug];
  const token = typeof window !== 'undefined' ? (localStorage.getItem('admin_token') || '') : '';
  const [initialSections, setInitialSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const pageDoc = await AdminService.getPage(slug, token);
        if (alive) {
          setInitialSections(Array.isArray(pageDoc?.sections) ? pageDoc.sections : []);
        }
      } catch (_e) {
        if (alive) setInitialSections([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [slug, token]);

  if (!Component) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <InlineEditProvider slug={slug} token={token} editing={true} initialSections={initialSections}>
      <Component />
    </InlineEditProvider>
  );
};

export default AdminEditPage;
